import Flickity from 'flickity';
import 'flickity/css/flickity.css';

(function (Drupal) {
  Drupal.behaviors.useFlickity = {
    attach: function (context, settings) {
      const useflickityBasic = document.querySelector(".useflickity--basic .view-content");
      const flickityContainers = document.querySelectorAll('.useflickity--groupcells .view-content');
      
      if (!flickityContainers) return;

      flickityContainers.forEach(container => {
        new Flickity(container, {
          cellAlign: 'left',
          contain: true,
          groupCells: true,
        });
      });      

      if (!useflickityBasic) return;

      const useflickityBasicItems = useflickityBasic.querySelectorAll(".views-row")        
      if (useflickityBasic && useflickityBasicItems.length > 1 ){
        const flkty = new Flickity( '.useflickity--basic .view-content', {
          cellAlign: 'left',
          contain: true
        });     
      }

      const deviceDetect = {
        breakpointMobile: 768,
        isMobile: () => {
          return window.matchMedia(`(max-width: ${deviceDetect.breakpointMobile}px)`).matches;
        },
      };
      if(deviceDetect.isMobile()) {
        const flickityContainersMb = document.querySelectorAll('.useflickity--groupcells-only-mb .view-content');
        flickityContainersMb.forEach(container => {
          new Flickity(container, {
            cellAlign: 'left',
            contain: true,
            groupCells: true,
          });
        });
      }
    }
  }
})(Drupal);
